import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center bg-black">
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/60">
        <img
          src="https://static.readdy.ai/image/4290f71dfbaa025f6a9f1c6e0e6bc4ce/d504531d40e7b831bf70da926b5e505c.jpeg"
          alt="JMS Train Rides"
          className="w-full h-full object-cover object-top"
        />
      </div>
      
      <div className="relative z-10 container mx-auto px-6 text-center">
        <div className="inline-block mb-8 px-6 py-2 bg-red-600 rounded-full">
          <span className="text-white text-sm font-semibold uppercase tracking-wide">WE Support Special Needs Children</span>
        </div>
        
        <h1 className="text-7xl md:text-8xl font-bold text-white mb-6 leading-tight">
          JMS Train Rides
        </h1>
        
        <p className="text-lg text-white/100 mb-12 max-w-3xl mx-auto leading-relaxed">
          Experience the magic of our custom-built train rides featuring a modified tractor and handcrafted train cars. 
          Specializing in charity events and holiday celebrations with a special focus on special needs children.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
          <a 
            href="#contact" 
            className="whitespace-nowrap px-10 py-4 bg-red-600 text-white text-lg font-semibold rounded-lg hover:bg-red-700 transition-all duration-300 hover:scale-105 cursor-pointer flex items-center gap-3"
          >
            Book a Ride
            <i className="ri-arrow-right-line text-xl"></i>
          </a>
          <a 
            href="#about" 
            className="whitespace-nowrap px-10 py-4 border-2 border-red-600 text-white text-lg font-semibold rounded-lg hover:bg-red-600/10 transition-all duration-300 cursor-pointer"
          >
            Learn About Our Mission
          </a>
        </div>
        
        <div className="mt-16 flex flex-wrap justify-center items-center gap-8 text-white text-lg">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-wheelchair-line text-white text-3xl"></i>
            </div>
            <span>Fully Accessible</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-shield-check-line text-white text-3xl"></i>
            </div>
            <span>Licensed &amp; Insured</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-heart-line text-white text-3xl"></i>
            </div>
            <span>Works With Registered Charities</span>
          </div>
        </div>
      </div>
    </section>
  );
}